import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import LazyLoad from 'react-lazyload';
import { Row, Col } from 'react-flexbox-grid';
import { Accordion } from 'react-accessible-accordion';
import {
  Accordion as AccordionCustom,
  SectionHeader,
  RelatedArticles,
  UnorderedList,
  Paragraph,
  FullwidthImage,
} from 'components';

const MeetTeam = ({ allArticles }) => (
  <StaticQuery
    query={graphql`
      query {
        teamImage: file(
          relativePath: { eq: "machine-learning/ai-team-having-meeting.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Accordion className={'hide-mobile'}>
        <AccordionCustom
          id={'ml-team'}
          backgroundColor={'pigeon-post'}
          headline={'Meet the AI Team'}
          headingType={2}
          lead={
            'AI, Machine Learning and Deep Neural Networks can help you with a number of problems'
          }
          lineColor={'black'}
          fontColors={['white', 'white', 'black']}
          lessButton
        >
          <>
            <div className={'w-container'}>
              <div
                className={'accordion__content machine-learning__accordion'}
              >
                <Row className={'no-gap'}>
                  <Col sm={12} md={6}>
                    <div className={'accordion__inner'}>
                      <SectionHeader
                        size={'small'}
                        additionalClass={'accordion__title'}
                      >
                        Size
                      </SectionHeader>
                      <Paragraph
                        size={'large'}
                        additionalClass={
                          'text--bold text--blue-light accordion__description'
                        }
                      >
                        5
                      </Paragraph>
                    </div>
                  </Col>
                  <Col sm={12} md={6}>
                    <div className={'accordion__inner'}>
                      <SectionHeader
                        size={'small'}
                        additionalClass={'accordion__title'}
                      >
                        Years of experience
                      </SectionHeader>
                      <Paragraph
                        size={'large'}
                        additionalClass={
                          'text--bold text--blue-light accordion__description'
                        }
                      >
                        1.5
                      </Paragraph>
                    </div>
                  </Col>
                </Row>
                <Row className={'no-gap'}>
                  <Col sm={12} md={6}>
                    <div className={'accordion__inner'}>
                      <SectionHeader
                        size={'small'}
                        additionalClass={'accordion__title'}
                      >
                        Accountabilities
                      </SectionHeader>
                      <UnorderedList
                        containerClass={'accordion__description'}
                        additionalClass={'text--light text--black'}
                        items={[
                          'Advising clients on the best AI solution',
                          'Validating the business hypothesis',
                          'Researching, developing and implementing the AI solution',
                          'Integrating the AI solution with client’s existing software',
                        ]}
                      />
                    </div>
                  </Col>
                  <Col sm={12} md={6}>
                    <div className={'accordion__inner'}>
                      <SectionHeader
                        size={'small'}
                        additionalClass={'accordion__title'}
                      >
                        Culture
                      </SectionHeader>
                      <UnorderedList
                        containerClass={'accordion__description'}
                        additionalClass={'text--light text--black'}
                        items={[
                          'pro-risk',
                          'business goals-oriented',
                          'constant learners',
                          'analytical',
                          'agile',
                          'lean thinking (build, measure, learn)',
                        ]}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className={'no-gap'}>
                  <Col sm={12} md={6}>
                    <div className={'accordion__inner'}>
                      <SectionHeader
                        size={'small'}
                        additionalClass={'accordion__title'}
                      >
                        Knowledge
                      </SectionHeader>
                      <UnorderedList
                        containerClass={'accordion__description--bullets'}
                        additionalClass={'text--light text--black'}
                        columns={2}
                        items={[
                          'deep learning',
                          'feature engineering',
                          'decision trees',
                          'random forest',
                          'extra trees',
                          'boosting (XGBoost, LightGBM, CatBoost)',
                          'hyperparameters optimization',
                          'cross validation',
                          'feature importance',
                          'learning curve',
                          'convolutional neural network (CNN)',
                          'spatial statistics',
                          'bayesian modeling/machine learning',
                        ]}
                      />
                    </div>
                  </Col>
                  <Col sm={12} md={6}>
                    <div className={'accordion__inner'}>
                      <SectionHeader
                        size={'small'}
                        additionalClass={'accordion__title'}
                      >
                        Technologies
                      </SectionHeader>
                      <UnorderedList
                        containerClass={'accordion__description'}
                        additionalClass={'text--light text--black'}
                        items={[
                          'Python, scikit-learn, Keras, TensorFlow, XGBoost, LightGBM, CatBoost, Hyperopt, Flask, Jupyter, MS Azure, Amazon Web Services, IBM Cloud, Google Cloud, Pymc3, Theano, Gensim, and&nbspNLTK.',
                        ]}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <FullwidthImage image={data.teamImage.childImageSharp.fluid} />
          </>
          {allArticles && (
            <LazyLoad once offset={200}>
              <RelatedArticles
                id={'ml-team-articles'}
                related={[{ title: 'CONTACT' }].concat(
                  allArticles.edges.map(edge => ({
                    title: edge.node.frontmatter.title,
                  })),
                )}
                allArticles={allArticles}
                sectionTitle={false}
                fixed
              >
                <SectionHeader
                  size={'small'}
                  description={
                    'Read our latest articles and explore the fascinating world of new advancements in technology and how they impact on businesses around the world.'
                  }
                  fixed
                  additionalClass={'machine-learning__related-articles'}
                >
                  Learn more about AI, machine learning and neural networks
                </SectionHeader>
              </RelatedArticles>
            </LazyLoad>
          )}
        </AccordionCustom>
      </Accordion>
    )}
  />
);

export default MeetTeam;
